import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="purchase" className="w-full bg-bg-primary py-12 md:py-20 px-4" data-id="element-39">
      <div className="max-w-6xl mx-auto" data-id="element-40">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-41">
          {/* Left: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-42">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-4 md:mb-6 leading-tight" data-id="element-43">
              Accede al Ecosistema Empresarial completo
            </h2>

            <p className="text-lg md:text-xl text-text-secondary mb-6 md:mb-8 leading-relaxed" data-id="element-44">
              Descarga inmediata. Ebook PDF. Sistema ejecutable.
            </p>

            <div className="bg-bg-card border border-accent-primary border-opacity-20 rounded-lg p-5 md:p-6 mb-6 md:mb-8" data-id="element-45">
              <div className="flex items-center justify-between mb-2 md:mb-3" data-id="element-46">
                <span className="text-xl md:text-2xl text-text-secondary line-through" data-id="element-47">
                  $47 USD
                </span>
                <span className="text-xs md:text-sm font-bold text-accent-primary bg-accent-primary bg-opacity-10 px-2 md:px-3 py-1 md:py-1.5 rounded-lg" data-id="element-48">
                  86% DE DESCUENTO
                </span>
              </div>
              <div className="flex items-baseline mb-3 md:mb-4" data-id="element-49">
                <span className="text-4xl md:text-5xl font-bold text-accent-primary" data-id="element-50">
                  $6.39
                </span>
                <span className="text-lg md:text-xl text-text-secondary ml-2" data-id="element-51">
                  USD
                </span>
              </div>
              <p className="text-sm md:text-base text-text-secondary" data-id="element-52">
                Inversión única • Acceso permanente
              </p>
            </div>

            <motion.a href="https://rrdigitalpro.com/cart/44846096973878:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block w-full md:w-auto px-6 md:px-8 py-3 md:py-4 bg-accent-primary text-bg-primary font-bold text-base md:text-lg rounded-lg hover:bg-opacity-90 transition-all mb-3 md:mb-4 text-center" aria-label="Acceder al Ecosistema Empresarial" data-id="element-53">
              Acceder al Ecosistema Empresarial
            </motion.a>

            <p className="text-xs md:text-sm text-text-secondary" data-id="element-54">
              Acceso inmediato • Ebook PDF
            </p>
          </motion.div>

          {/* Right: Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-first lg:order-last" data-id="element-55">
            <img src="https://cdn.magicpatterns.com/uploads/1dfDuu6s9PDNbf6vN1DsHn/_mockup_arquitectura_USA2.png" alt="Ebook Arquitectura Empresarial USA" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-56" />
          </motion.div>
        </div>
      </div>
    </section>;
}